import * as uuid from 'uuid';

import { API_URL as BASE_API_URL } from '@funnels/constants';
import { MOCK_DATA } from '@funnels/mockdata';
import { ServerIncomeCreate, ServerIncomeUpdate } from '@funnels/types';

import { axios } from '../_common/axios';

const SHOULD_USE_MOCK_API = localStorage.getItem('_lendi_funnels_debug_use_mock_api') === 'true';
const API_URL = `${BASE_API_URL}/v1`;

function create(applicationId: string, income: ServerIncomeCreate): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: { id: uuid.v4() } });
  }

  return axios.post(`${API_URL}/applications/${applicationId}/incomes`, income).then((res) => res.data);
}

function del(applicationId: string, incomeId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve();
  }

  return axios.delete(`${API_URL}/applications/${applicationId}/incomes/${incomeId}`).then((res) => res.data);
}

function fetch(applicationId: string): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve({ data: MOCK_DATA.incomes });
  }

  return axios.get(`${API_URL}/applications/${applicationId}/incomes`).then((res) => res.data);
}

function update(applicationId: string, incomeId: string, income: ServerIncomeUpdate): Promise<any> {
  if (SHOULD_USE_MOCK_API) {
    return Promise.resolve();
  }

  return axios.put(`${API_URL}/applications/${applicationId}/incomes/${incomeId}`, income).then((res) => res.data);
}

export default { create, del, fetch, update };
